module.exports = __webpack_public_path__ + "static/media/icons-system-chevron-right.7624cbe7.svg";